import React from 'react';
import UpgradeSequencer from '../components/upgradesequencer';

export default function UpgradePage() {
  return <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}><UpgradeSequencer /></div>;
}